import { render, staticRenderFns } from "./SubscriptionStatus.vue?vue&type=template&id=ff72fe24&"
import script from "./SubscriptionStatus.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionStatus.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionStatus.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports